import { t as uiT } from '../../utils/ui-strings';
import { cn } from '../../utils/cn';

type IdleState = 'active' | 'warning' | 'timed_out';

interface PlaygroundNoticesProps {
  language: string;
  errorMessage: string | null;
  isSessionClosed: boolean;
  idleState: IdleState;
  idleNoticeMessage: string | null;
  sessionTransitionMessage: string | null;
  onStartNewChat: () => void;
}

const NewChatButton = ({ language, onClick }: { language: string; onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    className="rounded-sm border border-brand-blue bg-brand-blue px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white transition-colors hover:bg-white hover:text-brand-blue"
  >
    {uiT('start_new_chat', language)}
  </button>
);

export const PlaygroundNotices = ({
  language,
  errorMessage,
  isSessionClosed,
  idleState,
  idleNoticeMessage,
  sessionTransitionMessage,
  onStartNewChat,
}: PlaygroundNoticesProps) => (
  <>
    {errorMessage ? (
      <div className="mx-5 mb-3 rounded border border-alert-error/30 bg-alert-error/10 px-3 py-2 text-sm text-alert-error">
        {errorMessage}
      </div>
    ) : null}

    {isSessionClosed ? (
      <div className="mx-5 mb-3 rounded border border-brand-blue/30 bg-brand-blue/5 px-3 py-2 text-sm text-brand-blue">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span>{uiT('chat_closed', language)}</span>
          <NewChatButton language={language} onClick={onStartNewChat} />
        </div>
      </div>
    ) : idleNoticeMessage ? (
      <div
        className={cn(
          'mx-5 mb-3 rounded border px-3 py-2 text-sm',
          idleState === 'timed_out'
            ? 'border-amber-500/30 bg-amber-500/10 text-amber-700'
            : 'border-amber-400/30 bg-amber-400/10 text-amber-800',
        )}
      >
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span>{idleNoticeMessage}</span>
          {idleState === 'timed_out' ? (
            <NewChatButton language={language} onClick={onStartNewChat} />
          ) : null}
        </div>
      </div>
    ) : sessionTransitionMessage ? (
      <div className="mx-5 mb-3 rounded border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-700">
        {sessionTransitionMessage}
      </div>
    ) : null}
  </>
);
